// extracted by mini-css-extract-plugin
export default {"page_wrapper":"style_page_wrapper__s11VL","load_btn":"style_load_btn__8KTE6","progress_box":"style_progress_box__CxCEv","loading_bar":"style_loading_bar__Fpnh+"};